import { render } from "./StudentPeriodAttendanceDetailView.vue?vue&type=template&id=1d124038"
import script from "./StudentPeriodAttendanceDetailView.vue?vue&type=script&lang=js"
export * from "./StudentPeriodAttendanceDetailView.vue?vue&type=script&lang=js"

import "./StudentPeriodAttendanceDetailView.vue?vue&type=style&index=0&id=1d124038&lang=css"

import exportComponent from "/var/jenkins_home/workspace/prod-fe-app-myqampus/node_modules/vue-cli-plugin-vue-next/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__